import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { useTheme } from '../../../contexts/ThemeContext';

const DateRangeInput = ({
  value,
  onChange,
  placeholder,
  format = 'DD/MM/YYYY',
  style,
  className,
  ...props
}) => {
  const { theme } = useTheme();

  return (
    <DatePicker.RangePicker
      autoComplete="off"
      placeholder={
        Array.isArray(placeholder)
          ? placeholder
          : placeholder
          ? [placeholder, placeholder]
          : undefined
      }
      value={
        value
          ? [dayjs(value[0]), dayjs(value[1])]
          : [null, null]
      }
      onChange={onChange}
      style={{
        width: "100%",
        backgroundColor: theme.background,
        color: theme.textSecondary,
        borderColor: theme.border,
        ...style
      }}
      className={className}
      format={format}
      {...props}
    />
  );
};

DateRangeInput.propTypes = {
  value: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  format: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default DateRangeInput; 